module.exports = __webpack_public_path__ + "static/img/116.848ad0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/116.jpg
// module id = 2wK6
// module chunks = 2